import * as Cookies from 'js-cookie';
import React from 'react';
import { RouteComponentProps,withRouter } from 'react-router';

import { Messages } from '../../codegen/Localize';
import { Location } from '../../common/react/Location';
import { MobileAppService } from '../services/MobileAppService';


export interface MobileAppBannerProps extends RouteComponentProps{
}

export interface MobileAppBannerState {
    readonly dismissed: boolean;
}

class MobileAppBannerComponent extends React.Component<MobileAppBannerProps, MobileAppBannerState>{

    constructor(props: MobileAppBannerProps) {
        super(props);
        this.state = {dismissed: false};
    }

    public render() {
        /* eslint-disable jsx-a11y/no-static-element-interactions */
        /* eslint-disable jsx-a11y/click-events-have-key-events */
        /* eslint-disable jsx-a11y/anchor-is-valid */
        /* eslint-disable jsx-a11y/alt-text */
        /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
        if (this.shouldShowAppBanner()) {
            return (
                <div className='tb-app-banner'>
                  <img className='tb-app-banner-close'
                    src='img/close_app_banner.png'
                    onClick={this.closeAppBanner} />
                  <img className='tb-banner-logo'
                    src='img/banner-logo-96.png' />
                  <a className='tb-app-banner-link-area'
                    onClick={MobileAppService.onPressAppBanner}>
                    <p className='tb-app-banner-text-area'>
                      <span>Tableau</span>
                      <span className='tb-app-banner-link-text'>{Messages.openInTableauMobile()}</span>
                    </p>
                  </a>
                </div>
              );
        } else {
            return null;
        }
    }

    private closeAppBanner = () => {
        this.setState({dismissed: true});
        const expireDate = new Date();
        expireDate.setDate(expireDate.getDate() + 7);
        Cookies.set(MobileAppService.HIDE_APP_BANNER_COOKIE, 'true', { 'expires': expireDate });
    }

    private shouldShowAppBanner() {
        return !this.state.dismissed && MobileAppService.shouldShowAppBanner(Location.instance.href());
    }
}


// We add this here to so location is passed down as part of props. We don't actually explicitly use it
// but we need it to be included so that this component re-renders whenever the location changes
export const MobileAppBanner = withRouter(MobileAppBannerComponent);